const doctorList = {
  tableList: [
    {
      id: 1,
      text: "No",
      name: "sNo",
      visible: true,
      className: "text-center",
    },

    // {
    //     'id': 2,
    //     'text': 'Unit',
    //     'visible': true,
    //     'className': null
    // }, {
    //     'id': 3,
    //     'text': 'Unit Location',
    //     'visible': true,
    //     'className': null
    // }, {
    //     'id': 4,
    //     'text': 'Department',
    //     'visible': true,
    //     'className': null
    // },

    {
      id: 5,
      text: "Doctor",
      name: "name",
      visible: true,
      className: null,
    },
    {
      id: 4,
      text: "Doctor Code",
      name: "id",
      visible: true,
      className: null,
    },

    {
      id: 4,
      text: "Department",
      name: "departmentname",
      visible: true,
      className: null,
    },

    {
      id: 6,
      text: "Status",
      name: "status",
      visible: true,
      className: null,
    },
    {
      id: 7,
      text: "Action",
      name: "action",
      visible: true,
      className: null,
    },
  ],
};

const doctorForm = {
  feilds: [
    {
      id: 0,
      name: "newDoctor",
      text: "New Doctor",
      visible: true,
      element: "label",
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "doctorname",
      text: "Enter Doctor Name",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter Doctor Name",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Doctor Name",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 2,
      name: "empid",
      text: "Enter Doctor ID",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter Doctor ID",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Doctor ID",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 3,
      name: "unit",
      text: "Unit",
      visible: true,
      icon: "lock",
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Unit",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Select Unit",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 4,
      name: "specialization",
      text: "Specialization",
      visible: true,
      icon: null,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter Specialization",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Specialization",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 5,
      name: "department",
      text: "Department",
      visible: true,
      icon: null,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Department",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Select Department",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 6,
      name: "experience",
      text: "Experience",
      visible: true,
      icon: null,
      element: "input",
      required: true,
      input_type: "number",
      placeholder: "Enter Experience in Years",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Experience",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 6,
      name: "vitals_required",
      text: "Vitals",
      visible: true,
      icon: null,
      element: "input",
      required: true,
      input_type: "checkbox", // Changed to checkbox
      placeholder: " ", // Removed for checkboxes
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please select Vitals",
        },
      ],
      errors: [],
      value: false,
      valid: false,
      state: "",
      disable: false,
      className: ["inline-checkbox"], // You can add classes here if needed
    },
    
     
    {
      id: 6,
      name: "profile_pic",
      text: "Profile",
      visible: true,
      icon: null,
      element: "file",
      required: true,
      input_type: "text",
      placeholder: "Enter Experience in Years",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Experience",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 0,
      name: "button",
      text: "Doctor",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};
const doctorlistfilter ={
  feilds: [
      {
          id: 1,
          name: 'doctorName',
          title: 'Name',
          visible: true,
          element: 'input',
          required: true,
          input_type: 'text',
          placeholder: 'Enter',
          icon: 'user',
          rules: [
              {
                  test: (value) => {
                      return (value !== null && value.length > 0);
                  },
                  message: 'Please Enter Name'
              }
          ],
          errors: [],
          value: null,
          valid: false,
          state: '',
          disable: false,
          className: 'col-2'
      }, 
     {
          id: 2,
          name: 'unit',
          title: 'Unit',
          text2: 'Filter By:',
          visible: true,
          element: 'select2',
          required: true,
          input_type: 'select',
          placeholder: 'Unit',
          icon: 'user',
          rules: [
              {
                  // test: (value) => {
                  //     //return (value !== null && value.length > 0);
                  //     return true;
                  // },
                  // message: 'Please Select unit'
              }
          ],
          errors: [],
          value: null,
          valid: false,
          state: '',
          disable: true,
          className: 'col-4'
      },
      {
          id: 2,
          name: 'department',
          text: 'Department',
          visible: true,
          element: 'select2',
          required: true,
          input_type: 'select',
          placeholder: 'Department',
          icon: 'user',
          rules: [
              {
                  // test: (value) => {
                  //     //return (value !== null && value.length > 0);
                  //     return true;
                  // },
                  // message: 'Please Select Specialty'
              }
          ],
          errors: [],
          value: null,
          valid: false,
          state: '',
          disable: true,
          className: 'col-5'
      },
  ]
}
const serverListFilter ={
  feilds: [
      {
          id: 1,
          name: 'servicesName',
          title: 'Name',
          visible: true,
          element: 'input',
          required: true,
          input_type: 'text',
          placeholder: 'Enter',
          icon: 'user',
          // rules: [
          //     {
          //         test: (value) => {
          //             return (value !== null && value.length > 0);
          //         },
          //         message: 'Please Enter Name'
          //     }
          // ],
          errors: [],
          value: null,
          valid: false,
          state: '',
          disable: false,
          className: 'col-2'
      }
  ]
}
const usersListFilter ={
  feilds: [
      {
          id: 1,
          name: 'userName',
          title: 'Name',
          visible: true,
          element: 'input',
          required: true,
          input_type: 'text',
          placeholder: 'Enter',
          icon: 'user',
          // rules: [
          //     {
          //         test: (value) => {
          //             return (value !== null && value.length > 0);
          //         },
          //         message: 'Please Enter Name'
          //     }
          // ],
          errors: [],
          value: null,
          valid: false,
          state: '',
          disable: false,
          className: 'col-2'
      }
  ]
}

export { doctorList, doctorForm,doctorlistfilter,serverListFilter,usersListFilter };
